import Booking from "./Booking";
import Model from "./Model";

export default class BookingParticipant extends Model {

    constructor(data) {

        super(data, {
            gender: null,
            firstname: null,
            lastname: null,
            birthday: null,
            adult: true,
            child: false,
        });

        this.relation('booking', Booking);
    }
}
